import { COUPON_SERVICE_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";

AxiosCurlirize(axios, () => {});

export const useReminderDetailsAPI = () => {
  const [reminderDetails, setReminderDetails] = useState<any>(null);

  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (reminder_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${COUPON_SERVICE_APIS?.REMINDER_API?.baseURL}reminder-details?reminder_id=${reminder_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status) {
              setReminderDetails(res.data.data);
              //
            } else {
              setReminderDetails(null);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              setReminderDetails([]);
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              setReminderDetails(null);
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              setReminderDetails(null);
              toast.error("Server error 500");
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        setReminderDetails(null);
      }
    },
    [dispatch],
  );
  return { execute, reminderDetails };
};
